import Edit from './Edit'
import { PasswordChange, AddDocuments, ChangeRole } from './components'

export { Edit, PasswordChange, AddDocuments, ChangeRole }
